module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', [_vm._v("The Line")]), _vm._v(" "), _vm._l((_vm.lines), function(d, i) {
    return _c('div', {
      key: i,
      staticClass: "line"
    }, [_vm._v("\n    " + _vm._s(_vm.moment(d.date, _vm.util.dateString).format("ddd")) + "\n    "), _c('div', {
      staticClass: "flexRow blockRow"
    }, _vm._l((d.blocks), function(n, i) {
      return _c('div', {
        key: i,
        staticClass: "block",
        class: {
          quota: n.quota
        },
        style: (("background-color: " + (n.color) + ";}")),
        attrs: {
          "title": n.title
        }
      })
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "flexRow completionStats"
  }, [_c('div', [_vm._v("\n      Line Completion\n      "), _c('h2', [_vm._v(_vm._s(_vm.lineCompletion.fraction))]), _vm._v(" "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v(_vm._s(_vm.lineCompletion.percentage) + "%")])]), _vm._v(" "), _c('div', [_vm._v("\n      Block Completion\n      "), _c('h2', [_vm._v(_vm._s(_vm.blockCompletion.fraction))]), _vm._v(" "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v(_vm._s(_vm.blockCompletion.percentage) + "%")])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d7a37a3!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/LineView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3d7a37a3!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/LineView.vue
// module chunks = 0